import './a11y.scss'; // we need to import the css file here, so the webpack will process it and add it to the dist folder
import { IdcMessageScreenReaderService } from "./idc-message-screen-reader-service/idc-message-screen-reader-service";
import { AccessibilityGlobals } from "./accessibility-globals/accessibility-globals";
// init the screenReaderService script
const idcMessageScreenReaderService = new IdcMessageScreenReaderService();
idcMessageScreenReaderService.init();
/**
 * init skip-links script - after page loads completely
 **/
try {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(() => {
            AccessibilityGlobals.init();
        }, 1);
    }
    else {
        document.addEventListener("DOMContentLoaded", () => {
            AccessibilityGlobals.init();
        });
    }
}
catch (error) {
    console.error(error);
}
